
import React from 'react';
import { useLanguage } from './LanguageContext';
import { Globe } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';

export const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  
  // Handler to set language and persist the choice
  const handleLanguageChange = (newLanguage: 'pt' | 'en' | 'es' | 'fr') => {
    setLanguage(newLanguage);
    // The context will handle storing in localStorage
  };
  
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="text-slate-gray-dark dark:text-gray-300 hover:bg-transparent">
          <Globe className="h-5 w-5" />
          <span className="sr-only">Toggle language</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-white dark:bg-gray-800">
        <DropdownMenuItem 
          onClick={() => handleLanguageChange('pt')} 
          className={language === 'pt' ? 'bg-slate-100 dark:bg-gray-700' : ''}
        >
          Português
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => handleLanguageChange('en')} 
          className={language === 'en' ? 'bg-slate-100 dark:bg-gray-700' : ''}
        >
          English
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => handleLanguageChange('es')} 
          className={language === 'es' ? 'bg-slate-100 dark:bg-gray-700' : ''}
        >
          Español
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => handleLanguageChange('fr')} 
          className={language === 'fr' ? 'bg-slate-100 dark:bg-gray-700' : ''}
        >
          Français
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
